export * from '@primeuix/themes/aura/image';
export { default } from '@primeuix/themes/aura/image';
